import { AuthConfig } from '@quirion/types';
import { AuthHelper } from './utils/AuthHelper';
import { AUTH_CONFIG_BANKING } from '../constants';

export const isAuthenticated = (
  authConfig: AuthConfig = AUTH_CONFIG_BANKING,
): boolean => {
  const auth = new AuthHelper(authConfig);
  return auth.isAuthenticated();
};
